import { FormError } from '@shopify/react-form';

export enum FormSubmitStatuses {
  fail = 'fail',
  success = 'success',
}

export type SubmitError = { status: FormSubmitStatuses.fail; errors: FormError[] };
export type SubmitSuccess = { status: FormSubmitStatuses.success };
